/**
 * Loading page 用于各个页面的操作触发遮罩，避免重复点击操作
 * 2019-04-28 chenxiaojian
 */
import React from 'react';
import { Spin } from 'antd';

class Loading extends React.Component {


    render() {
        const { visible, message } = this.props;
        let dom = "";
        if (visible === true) {
            dom = (
                <div className="div-mask">
                    <Spin tip={message} size="large" style={{ top: '48%', position: "relative" }}>
                    </Spin>
                </div>
            );
        }
        return dom;
    };
}

export default Loading;